import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";

import ClientsDataTable from "./ClientsDataTable";
import { EnumWrapper } from "../../../utils/enums";
import { LANGUAGE_CODES } from "../../../utils/enums/enums";

const ClientsPage = (props) => {
  return (
    <div className="full-height">
      {!!props.children ? (
        props.children
      ) : (
        <div className="full-height">
          <div className="page-header">
            <div className="main clearfix">
              <div className="main-name">
                <h2>
                  <FormattedMessage id="clients.title" />
                </h2>
              </div>
            </div>
          </div>
          <div className="sub-container">
            <div className="sub-content">
              <EnumWrapper showLoading={false} enum={LANGUAGE_CODES}>
                <ClientsDataTable />
              </EnumWrapper>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

ClientsPage.propTypes = {
  children: PropTypes.node,
};

export default ClientsPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/ClientsPage.js